module.exports = __webpack_public_path__ + "static/media/20190402_071241.01c5a4ce.jpg";